import React from 'react';
import useThrottle from '../../shared/hooks/throttle';

export default function PrevButton(props) {
  const handlePrevPage = () => {
    const pagination = document.querySelector(".timelineVertical .timelineBgPagination")
    const paginationLeft = pagination.scrollLeft
    const pages = document.querySelectorAll(".timelineVertical .timelineBgPaginationItem")
    const currentPage = [...pages].find(el => paginationLeft >= el.offsetLeft - 10 && paginationLeft < el.offsetLeft + el.offsetWidth - 10 )
    if (currentPage.previousSibling) {
      if (currentPage.previousSibling.previousSibling) {
        pagination.scrollTo({ left: currentPage.previousSibling.previousSibling.offsetLeft, behavior: 'smooth'})
      } else {
        pagination.scrollTo({ left: currentPage.previousSibling.offsetLeft, behavior: 'smooth'})
      }
    }
  }

  const invokeThrottlePreButton = useThrottle(() => {
    handlePrevPage();
  }, 500);

  const invokeHandleDrag = useThrottle(() => {
    handlePrevPage();
  }, 700);

  return (
    <React.Fragment>
      <div
        className={["arrowBox", "prev", "pc", props.disabled ? "disabled" : ""].filter(e => !!e).join(' ')}
        onDragOver={invokeHandleDrag}
      >
        <button className="btn-prev arrowBtn" onClick={invokeThrottlePreButton} disabled={props.disabled}><span className="arrow"></span></button>
        <p>前の20年</p>
      </div>
    </React.Fragment>
  )
}
